const m = window.require("@ember/-internals/metal");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;